import React from "react";
import { Sparkles, FileText, Loader2, BookOpen, Wand2 } from "lucide-react";

interface SuperLoaderProps {
  title?: string;
  description?: string;
  className?: string;
}

export const SuperLoader: React.FC<SuperLoaderProps> = ({
  title = "Loading",
  description = "Please wait...",
  className = ""
}) => {
  return (
    <div className={`flex flex-col items-center justify-center min-h-[300px] p-8 ${className}`}>
      {/* Simple spinner */}
      <div className="relative mb-6">
        <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
      </div>

      {/* Simple text */}
      <div className="text-center space-y-2">
        <h3 className="text-lg font-medium text-gray-900">
          {title}
        </h3>
        <p className="text-gray-600 text-sm">
          {description}
        </p>
      </div>
    </div>
  );
};

export default SuperLoader;
